import React, {useEffect, useState} from 'react';
import {Accordion, Row, Col, Form} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from './IconButton';
import {listUserClub} from '../../lib/api/club';
import {listSelection , listGender} from '../../lib/api/player';

const SearchPlayerAccordion = ({handleSearch, handleExport}) => {

    const [search, setSearch] = useState({});
    const [selection, setSelection] = useState([]);
    const [clubs, setClubs] = useState([]);
    const [gender, setGender] = useState([]);

    const handleInputChange = e => {
        const { name, value } = e.target;

        console.log('name', name, value);

        setSearch(prev => {
            const updated = { ...prev };
            console.log('updated',updated)
            if (value === '') {
                delete updated[name]; // obriši polje ako je prazno
            } else {
                updated[name] = value;
            }
            return updated;
        });
    };



    // const handleInputSearch = e => {
    //     handleSearch(search)
    // };

    useEffect(() => {
        (async () => {

            console.log('Search state changed:', search);

            try {
                const rowSelectionRaw = await listSelection();
                const rowSelection = rowSelectionRaw.filter(item => item.selection_id !== 4);
                setSelection(rowSelection);

                const rowClubs = await listUserClub()
                setClubs(rowClubs);

                const rowGender = await listGender()
                setGender(rowGender);

            } catch (error) {
            }
        })();
    }, []);

    return (
        <Accordion defaultActiveKey={null}>
            <Accordion.Item eventKey="0">
                <Accordion.Header><FontAwesomeIcon icon="search" className="fs-10 me-2" /><strong>Pretraga</strong></Accordion.Header>
                <Accordion.Body>
                    <Form.Group as={Col} md="12" method="POST" encType="multipart/form-data" noValidate>
                        <Row className="flex-between-center mb-3">
                            <Col md={4}>
                                <Form.Label>Klub</Form.Label>
                                <Form.Select name="t_club_entities_id"  onChange={handleInputChange}>
                                    {clubs.length > 1 && <option value="">Izaberi</option>}
                                    {clubs.map(p => (
                                        <option key={p.entities_id} value={p.entities_id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Label>Naziv</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="t_name"
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label>Status</Form.Label>
                                <Form.Select name="t_selection_id"  onChange={handleInputChange}>
                                    <option value="">Izaberi</option>
                                    {selection.map(p => (
                                        <option key={p.selection_id} value={p.selection_id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="flex-between-center mb-3">
                            <Col md={4}>
                                <Form.Label>Pol</Form.Label>
                                <Form.Select name="t_gender"  onChange={handleInputChange}>
                                    <option value="">Izaberi</option>
                                    {gender.map(p => (
                                        <option key={p.gender_type_id} value={p.gender_type_id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md="12" className="text-end mt-2">
                                <IconButton
                                    className="rounded-pill me-2 mb-1"
                                    variant="falcon-primary"
                                    icon="external-link-alt"
                                    transform="shrink-3"
                                    onClick={() => handleExport(search)}
                                >
                                    Export
                                </IconButton>

                                <IconButton
                                    className="rounded-pill me-1 mb-1"
                                    variant="falcon-primary"
                                    icon="search"
                                    transform="shrink-3"
                                    onClick={() => handleSearch(search)}
                                >
                                    Pretraga
                                </IconButton>
                            </Col>
                        </Row>
                    </Form.Group>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default SearchPlayerAccordion;
